// This icon file is generated automatically.
var PBankOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.97 6.22c.48 0 .68-.62.3-.9L7.28.96a.5.5 0 00-.58 0L.74 5.31c-.4.29-.2.9.3.9H2v5.85H.87a.13.13 0 00-.12.13V13c0 .07.06.13.13.13h12.24c.07 0 .13-.06.13-.13v-.81a.13.13 0 00-.13-.13H12V6.22h.97zM7 2.07l4.24 3.08H2.76L7 2.07zM3.12 6.22h1.83v5.84H3.12V6.22zm2.96 0H7.9v5.84H6.08V6.22zm4.8 5.84H9.03V6.22h1.85v5.84z", "fill-rule": "nonzero" } }] }, "name": "p-bank", "theme": "outlined" };
export default PBankOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PBankOutlined.js
// module id = 3235
// module chunks = 0